<template>
  <div class="row">
    <div class="col-12">
      <SectionTitle :content="'Equipos'" :has-line="true" />
    </div>
    <div class="col-12">
      <div class="row">
        <div class="col-12">
          <div class="container-table-striped">
            <div class="table-hover">
              <table class="table content-table-striped table-striped mb-5">
                <thead>
                  <tr class="row global-thead-dark thead-property pl-1">
                    <th class="col-2 font-weight-bold">
                      Equipo
                    </th>
                    <th class="col-6 bold">
                      Uso
                    </th>
                    <th class="col-4 bold">
                      Cambio
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="item in model.equipments"
                    :key="item.id"
                    class="row pl-2"
                  >
                    <td class="col-2 pl-3  d-flex align-items-center">
                      <h6 class="bold mb-0">
                        {{ item.recommendation.equipmentName }}
                      </h6>
                    </td>
                    <td
                      class="col-6 d-flex align-items-center justify-content-center "
                    >
                      <div class="row ">
                        <div class="col-12 p-0 mb-3">
                          <div class="row">
                            <div class="col-md-2 p-0 d-flex align-items-center">
                              <h6 class="bold mb-0">
                                Evaluación
                              </h6>
                            </div>

                            <div class="col-md-3  ">
                              <div
                                class="input-group d-flex align-items-center "
                              >
                                <input
                                  :id="'usedAtHome-' + item.recommendation.id"
                                  v-model="item.recommendation.usedAtHome"
                                  type="checkbox"
                                  :name="'usedAtHome-' + item.recommendation.id"
                                  class="option-input checkbox"
                                  :checked="item.recommendation.usedAtHome"
                                  :disabled="true"
                                />
                                <label
                                  class="mb-0"
                                  :for="'usedAtHome-' + item.recommendation.id"
                                >
                                  <span><i class="ic-check" /></span>
                                </label>
                                <span class="use-label">HOGAR</span>
                              </div>
                            </div>
                            <div class="col-md-3 text-center">
                              <div
                                class="input-group d-flex align-items-center"
                              >
                                <input
                                  :id="'usedInSchool-' + item.recommendation.id"
                                  v-model="item.recommendation.usedInSchool"
                                  type="checkbox"
                                  :name="
                                    'usedInSchool-' + item.recommendation.id
                                  "
                                  class="option-input checkbox"
                                  :checked="item.recommendation.usedInSchool"
                                  :disabled="true"
                                />
                                <label
                                  class="mb-0"
                                  :for="
                                    'usedInSchool-' + item.recommendation.id
                                  "
                                >
                                  <span><i class="ic-check" /></span>
                                </label>
                                <span class="use-label">ESCUELA</span>
                              </div>
                            </div>
                            <div class="col-md-3 text-center">
                              <div
                                class="input-group d-flex align-items-center "
                              >
                                <input
                                  :id="
                                    'usedInTherapy-' + item.recommendation.id
                                  "
                                  v-model="item.recommendation.usedInTherapy"
                                  type="checkbox"
                                  :name="
                                    'usedInTherapy-' + item.recommendation.id
                                  "
                                  class="option-input checkbox"
                                  :checked="item.recommendation.usedInTherapy"
                                  :disabled="true"
                                />
                                <label
                                  class="mb-0"
                                  :for="
                                    'usedInTherapy-' + item.recommendation.id
                                  "
                                >
                                  <span><i class="ic-check" /></span>
                                </label>
                                <span class="use-label">TERAPIA</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-12 p-0">
                          <div class="row">
                            <div class="col-md-2 p-0 d-flex align-items-center">
                              <h6 class="bold mb-0 ">
                                COMPU
                              </h6>
                            </div>
                            <div
                              class="col-md-3 text-center d-flex align-items-center"
                            >
                              <div
                                class="input-group d-flex align-items-center"
                              >
                                <input
                                  :id="
                                    'schoolUsedAtHome-' + item.recommendation.id
                                  "
                                  v-model="item.recommendation.schoolUsedAtHome"
                                  type="checkbox"
                                  :name="
                                    'schoolUsedAtHome-' + item.recommendation.id
                                  "
                                  vid="compuSchoolUsedAtHome"
                                  class="option-input checkbox"
                                  :checked="
                                    item.recommendation.schoolUsedAtHome
                                  "
                                  :disabled="readonly"
                                  @change="onChange(item)"
                                />
                                <label
                                  class="mb-0"
                                  :for="
                                    'schoolUsedAtHome-' + item.recommendation.id
                                  "
                                >
                                  <span><i class="ic-check" /></span>
                                </label>
                                <span class="use-label">HOGAR</span>
                              </div>
                            </div>
                            <div
                              class="col-md-3 text-center d-flex align-items-center"
                            >
                              <div
                                class="input-group d-flex align-items-center"
                              >
                                <input
                                  :id="
                                    'schoolUsedInSchool-' +
                                      item.recommendation.id
                                  "
                                  v-model="
                                    item.recommendation.schoolUsedInSchool
                                  "
                                  type="checkbox"
                                  :name="
                                    'schoolUsedInSchool-' +
                                      item.recommendation.id
                                  "
                                  class="option-input checkbox"
                                  :checked="
                                    item.recommendation.schoolUsedInSchool
                                  "
                                  :disabled="readonly"
                                  @change="onChange(item)"
                                />
                                <label
                                  class="mb-0"
                                  :for="
                                    'schoolUsedInSchool-' +
                                      item.recommendation.id
                                  "
                                >
                                  <span><i class="ic-check" /></span>
                                </label>
                                <span class="use-label">ESCUELA</span>
                              </div>
                            </div>
                            <div class="col-md-3 text-center">
                              <div
                                class="input-group d-flex align-items-center"
                              >
                                <input
                                  :id="
                                    'schoolUsedInTherapy-' +
                                      item.recommendation.id
                                  "
                                  v-model="
                                    item.recommendation.schoolUsedInTherapy
                                  "
                                  type="checkbox"
                                  :name="
                                    'schoolUsedInTherapy-' +
                                      item.recommendation.id
                                  "
                                  class="option-input checkbox"
                                  :checked="
                                    item.recommendation.schoolUsedInTherapy
                                  "
                                  :disabled="readonly"
                                  @change="onChange(item)"
                                />
                                <label
                                  class="mb-0"
                                  :for="
                                    'schoolUsedInTherapy-' +
                                      item.recommendation.id
                                  "
                                >
                                  <span><i class="ic-check" /></span>
                                </label>
                                <span class="use-label">TERAPIA</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td class="col-md-4 pr-4 text-center">
                      <div class="input-group d-flex align-items-center ">
                        <ValidationProvider
                          v-slot="{ errors }"
                          slim
                          :name="'reason-' + item.recommendation.id"
                          :rules="item.rules"
                        >
                          <CustomTextArea
                            v-show="true"
                            :id="'reason-' + item.recommendation.id"
                            v-model="item.recommendation.reason"
                            class="w-100"
                            :maxlength="3000"
                            :classes="['eq-field', 'text-left']"
                            :rows="2"
                            :placeholder="item.placeholder"
                            :error="errors[0]"
                            :custom-error-msg="errorMessage"
                            :disabled="readonly || !isUseDifferent(item)"
                          />
                        </ValidationProvider>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SectionTitle } from '@/components/pei/shared';
import CustomTextArea from '@/components/common/CustomTextArea';
import { ValidationProvider } from 'vee-validate';

export default {
  props: {
    model: {
      type: Object,
      default: () => {},
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isValid: false,
      validationMessages: [],
      errorMessage: '',
    };
  },
  components: {
    SectionTitle,
    CustomTextArea,
    ValidationProvider,
  },
  methods: {
    onChange(item) {
      item.rules = 'required';
      item.placeholder = 'Escriba aquí...';
      const isDefined = this.validateEquipmentUsesDefined(item);
      item.areEquipmentSchoolDefined = this.areEquipmentSchoolDefined(item);

      if (!isDefined) {
        item.recommendation.reason = '';
        item.rules = '';
        item.placeholder = '';
      }
    },
    isUseDifferent(item) {
      return this.validateEquipmentUsesDefined(item);
    },
    validateEquipmentUsesDefined(item) {
      if (
        item.recommendation.schoolUsedAtHome !=
          item.recommendation.usedAtHome ||
        item.recommendation.schoolUsedInSchool !=
          item.recommendation.usedInSchool ||
        item.recommendation.schoolUsedInTherapy !=
          item.recommendation.usedInTherapy
      ) {
        if (
          item.recommendation.schoolUsedAtHome == false &&
          item.recommendation.schoolUsedInSchool == false &&
          item.recommendation.schoolUsedInTherapy == false
        ) {
          return false;
        }
        return true;
      }
      return false;
    },
    areEquipmentSchoolDefined(item) {
      return (
        item.recommendation.schoolUsedAtHome === true ||
        item.recommendation.schoolUsedInSchool === true ||
        item.recommendation.schoolUsedInTherapy === true
      );
    },
    loadValidationMessages() {
      const messageCodes = ['191358'];
      const promise = this.$ApiGet(
        '/api/validationsmessages?messageCodes=' +
          messageCodes.join('&messageCodes=')
      );
      promise.then((res) => {
        this.validationMessages = res.data;
        this.errorMessage = this.getMessage('191358').name;
      });
    },
    getMessage(code) {
      const message = this.validationMessages.find(
        (element) => element.id == code
      );
      return message;
    },
  },
  mounted() {},
  computed: {},
  created() {
    this.loadValidationMessages();
  },
};
</script>

<style scoped src="@/assets/css/component/panel-simple.css"></style>
<style scoped src="@/assets/css/component/btn-dropdown.css"></style>
<style scoped src="@/assets/css/component/checkbox.css"></style>
<style scoped src="@/assets/css/component/radio-button.css"></style>

<style scoped>
.content-table-striped th {
  padding: 1.2rem 0rem 1.2rem 1rem !important;
}
.section-bottom-spacing {
  margin-bottom: 50px !important;
}

.section-left-spacing {
  margin-left: 10px;
}

.thead-property {
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 5px 5px 0px 0px;
}

.input-group d-flex align-items-center .hidden {
  display: none;
}
.input-group d-flex align-items-center .entry {
  height: 25px;
  position: relative;
  width: 110px;
}
.input-group d-flex align-items-center .circle {
  border: 1px solid #e2e2e2;
  border-radius: 50%;
  cursor: pointer;
  height: 20px;
  position: absolute;
  transition: border-color 300ms;
  width: 20px;
}
.input-group d-flex align-items-center .entry-label {
  cursor: pointer;
  font-weight: 800;
  margin-top: -3px;
  padding-left: 30px;
  user-select: none;
  -moz-user-select: none;
}
.input-group d-flex align-items-center .highlight {
  background: #2db782;
  border-radius: 50%;
  height: 10px;
  left: 5px;
  pointer-events: none;
  position: absolute;
  top: 5px;
  transition: transform 400ms cubic-bezier(0.175, 0.885, 0.32, 1.2);
  transform: translateX(0px);
  width: 10px;
}
.input-group
  d-flex
  align-items-center
  .hidden:nth-child(1):checked
  ~ .highlight {
  transform: translateY(0);
}
.input-group
  d-flex
  align-items-center
  .hidden:nth-child(3):checked
  ~ .highlight {
  transform: translateX(110px);
}
.input-group
  d-flex
  align-items-center
  .hidden:nth-child(1):checked
  + .entry
  .circle {
  border-color: #e2e2e2;
}
.use-label {
  font-size: 12px;
  color: #304156;
}
</style>
